module.exports = __webpack_public_path__ + "img/scene.df611ff8.png";